<template>
	<section v-if="hasAnyChips" class="Selection">
		<slot name="header"/>
		<TagsElement
			:chips="activeFilterChips"
			@elementRemovalRequest="removeFilter"
		/>
	</section>
</template>

<script setup lang="ts">
import TagsElement from '@components/TagsElement/TagsElement.vue';
import { useSearchStore } from '@stores/useSearchStore';
import { FilterType } from '@studyportals/omnisearch-interfaces';
import { computed } from 'vue';
import { getTuitionFeeChipLabel } from '@app/utils/formatTuitionRange';
import { formatLocationDisplayName } from '@app/utils/formatLocationDisplayName';
import type { IChip } from '@app/interfaces/dtos/IChip';
import type { IExtendedFilterValue } from '@shared/interfaces/dtos/IExtendedFilterValue';

const searchStore = useSearchStore();

const activeFilterChips = computed<IChip[]>(() => {

	return searchStore.changeableFiltersSelection
		.filter(filter => filter.type !== FilterType.KEYWORD || !searchStore.isKeywordPendingInterpretation)
		.flatMap((filter) => {
			return filter.values.map((value: IExtendedFilterValue) => {
				let label = value.name;

				if (filter.type === FilterType.COUNTRY) {
					label = formatLocationDisplayName(value.name, searchStore.userNationalityIso);
				} else if (filter.type === FilterType.TUITION_FEE) {
					label = getTuitionFeeChipLabel(value.id);
				}

				return {
					id: filter.type,
					value: value.id,
					label: label
				} as IChip;
			});
		});
});

const hasAnyChips = computed(() => {
	return activeFilterChips.value.length > 0;
});


const removeFilter = (index: number): void => {
	const chip = activeFilterChips.value[index];
	if (!chip) return;

	searchStore.removeFilterValueByType(chip.id as FilterType, chip.value);
};
</script>

<style scoped lang="scss">
	.Selection {
		background: $White;

		@include PaddingAreas(1.5, 1, 1, 1);

		@include Breakpoint(Large, ExtraLarge) {
			border-bottom: 1px solid $Grey-300;
		}
	}
</style>
